import { getGoodsList, getGoodsInfo, goodsEdit } from '@/api/goods'

const goods = {
  state: {
    goods_list: []
  },

  mutations: {
    SET_GOODS_LIST: (state, goodsList) => {
      state.goods_list = goodsList
    }
  },

  actions: {
    // 获取商品列表
    getGoodsList ({ commit, state }, payload) {
      return new Promise((resolve, reject) => {
        getGoodsList(payload).then((response) => {
          commit('SET_GOODS_LIST', response.data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取商品列表
    getGoodsInfo ({ commit, state }, goodsId) {
      return new Promise((resolve, reject) => {
        getGoodsInfo(goodsId).then((response) => {
          commit('SET_GOODS_LIST', response.data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 商品规格修改
    goodsEdit ({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        goodsEdit(data).then((response) => {
          commit('SET_GOODS_LIST', response.data)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default goods



// WEBPACK FOOTER //
// ./src/store/modules/goods.js